module.exports = __webpack_public_path__ + "img/selected5-min.b18d5689.png";